<template>
  <div class="purchase-detail-box">
    <v-title
      title="拜访详情"
      :isShowBack="true"
      :isDefaultBack="false"
      @backHandle="goBack()"
    >
    </v-title>
    <div class="visitInfo">
      <div class="visitInfo-list">
        <span>拜访人</span>
        <span class="fr">{{ clientList.visitPersonName }}</span>
      </div>
      <div class="visitInfo-list">
        <span>拜访时间</span>
        <span class="fr">{{ clientList.lastVisitTime }}</span>
      </div>
    </div>
    <div class="purchase-header" v-show="loading === false">
      <div class="name">
        <span class="clientName">{{ clientList.clientName }}</span>
      </div>
      <div class="purchase-header-list">
        <div class="purchase-header-item clearfix">
          <div>所在地区：{{ clientList.provinceName !== null ? clientList.provinceName +  clientList.cityName + clientList.districtName : "暂无所在地区" }}</div>
          <div>
            <div class="info">
              <div>地址：{{ clientList.address !== null ? clientList.address : "暂无地址" }}</div>
              <div>
                电话：{{ clientList.phone ? clientList.phone : "暂无联系电话" }}&nbsp;&nbsp;
              </div>
              <div>终端类型：{{ clientList.clientType !== null ? clientList.clientType : "暂无终端类型" }}</div>
            </div>
            <div class="icon">
              <div v-if="clientList.address" class="choice-list" @click="showActionSheet(clientList)">
                <img :src="require('@/assets/feedback/location.png')" alt="">
                <div>导航</div>
              </div>
              <div class="choice-list-phone">
                <a
                  @click="pushUserLog('点击电话号码')"
                  v-if="clientList.phone"
                  :href="`tel:${clientList.phone}`"
                >
                  <img :src="require('@/assets/feedback/telephone.png')" alt="">
                  <div>电话</div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="purchase-main">
      <div class="listTitle">产品信息1</div>
      <div class="purchase-main-list">
        <div v-if="clientList.productList.length ===0" class="purchase-main-list-item clearfix">
          暂无信息
        </div>
        <div
          v-for="(item, index) in clientList.productList"
          :key="index"
          class="purchase-main-list-item clearfix">
          <div class="product fl">
            {{ item.productName }}
          </div>
          <div class="fr price-box">
            <div class="count">
              <span class="count-number">￥{{ item.price }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="listTitle">产品信息2</div>
      <div class="purchase-main-list">
        <div v-if="clientList.competitiveProductList.length ===0" class="purchase-main-list-item clearfix">
          暂无信息
        </div>
        <div
          v-for="(item, index) in clientList.competitiveProductList"
          :key="index"
          class="purchase-main-list-item clearfix">
          <div class="product fl">
            {{ item.productName }}
          </div>
          <div class="fr price-box">
            <div class="count">
              <span class="count-number">￥{{ item.price }}</span>
            </div>
          </div>
        </div>
        <!-- <div
          v-for="(item, index) in clientList.competitiveProductList"
          :key="index"
          class="purchase-main-list-item">
          <div class="competitiveListTop">
            <span v-if="!item.productName">暂无信息</span>
            <span>{{ item.productName }}</span>
            <span class="fr">{{ item.price }}</span>
          </div>
          <div class="competitiveListBottom">
            <span>{{ item.name }}</span>
            <span class="fr">{{ item.price }}</span>
          </div>
        </div> -->
      </div>
      <div class="listTitle">其他信息</div>
      <div class="purchase-main-list">
        <div class="purchase-main-list-item clearfix">
          <div class="fl">
            联系人：
          </div>
          <div class="fr price-box">
            <div class="count">
              <span v-if="!clientList.clientInfo.contacts" class="count-number">暂无联系人</span>
            </div>
            <div class="count">
              <span v-if="clientList.clientInfo.contacts" class="count-number">{{ clientList.clientInfo.contacts }}</span>
            </div>
          </div>
        </div>
        <div class="purchase-main-list-item clearfix">
          <div class="fl">
            联系电话：
          </div>
          <div class="fr price-box">
            <div class="count">
              <span v-if="!clientList.clientInfo.contactsNumber" class="count-number">暂无联系电话</span>
            </div>
            <div class="count">
              <span v-if="clientList.clientInfo.contactsNumber" class="count-number">{{ clientList.clientInfo.contactsNumber }}</span>
            </div>
          </div>
        </div>
        <div class="purchase-main-list-item clearfix">
          <div class="fl remark">
            备注：
          </div>
          <div class="count price-box fr">
            <span v-if="!clientList.clientInfo.remark" class="count-number">暂无备注</span>
          </div>
          <div class="remarkInfo">
            <div class="count">
              <span class="count-number">{{ clientList.clientInfo.remark }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <custom-loading v-if="loading" :isMask="true"></custom-loading>
  </div>
</template>

<script>
// import { purchaseDetail } from '@/api/feedBack'
import { isWeiXin } from '@/utils/utils'
import CustomLoading from '@/components/CustomLoading.vue'
import { getVisitRecordDetails } from '@/api/clientVisit'
export default {
  name: 'visitDetail',
  components: {
    CustomLoading
  },
  computed: {
  },
  created () {
    console.log(111, this.$route.query.data)
    getVisitRecordDetails(this.$route.query.data).then((res) => {
      if (res.code === 1) {
        this.clientList = res.data
      }
    })
  },
  data () {
    return {
      otherInfoForm: {},
      clientList: {},
      prductModel: {},
      productField: [],
      productList: [
        {
          name: '产品ABC',
          price: 123
        },
        {
          name: '产品BCA',
          price: 456
        },
        {
          name: '产品BAC',
          price: 7.89
        }
      ],
      loading: false,
      keyword: '',
      clientDetail: {},
      detailData: '',
      searchData: ''
    }
  },

  filters: {
  },
  methods: {
    handleSubmit () {
      console.log(this.otherInfoForm)
      console.log(this.detailData.scaClientSearchTradingCompanyList.drugList)
      // this.$router.push({ name: 'visitSuccess', query: { } })
      // this.toastsub = this.$createToast({
      //   txt: '正在提交。。。',
      //   time: 0,
      //   mask: false
      // }).show()
      // this.toastsub.hide()
    },
    handleClick (cur) {
      this.current = cur
      // this.$nextTick(() => {
      //   this.$refs[this.refName].refreshAll()
      // })
    },
    // 显示导航操作列表
    showActionSheet (pointData) {
      const isWX = isWeiXin()
      if (isWX) {
        // 已获取定位时
        if (this.myPositionCenter) {
          this.$refs.mapDriving.show()
        } else {
          // 提示选择地区
          this.$createDialog({
            title: '提示',
            type: 'alert',
            content: '请先获取您的位置再进行路线导航！'
          }).show()
        }
        return false
      }
      this.$createActionSheet({
        data: [
          { content: '高德地图' },
          { content: '腾讯地图' },
          { content: '百度地图' }
        ],
        onSelect: (item, index) => {
          // 打开地图导航
          if (this.$store.state.UserAgent === 'ios') {
            if (index === 0) {
              // 高德地图时
              window.open(
                `iosamap://path?sourceApplication=applicationName&sid=BGVIS1&slat=39.92848272&slon=116.39560823&sname=我的位置&did=BGVIS2&dlat=${pointData.latitude}&dlon=${pointData.longitude}&dname=${pointData.clientName}&dev=0&t=0`
              )
            } else if (index === 1) {
              // 腾讯地图
              window.open(
                `qqmap://map/routeplan?type=drive&from=我的位置&fromcoord=CurrentLocation&to=${pointData.clientName}&tocoord=${pointData.latitude},${pointData.longitude}&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77`
              )
            } else if (index === 2) {
              // 百度地图
              window.open(
                `baidumap://map/direction?origin=我的位置&destination=name:${pointData.clientName}|latlng:${pointData.latitude},${pointData.longitude}&coord_type=gcj02&mode=driving&src=ios.sca.weiming`
              )
            }
          } else {
            if (index === 0) {
              // 高德地图时
              window.open(
                `amapuri://route/plan/?sourceApplication=amap&dlat=${pointData.latitude}&dlon=${pointData.longitude}&dev=1&t=0&dname=${pointData.clientName}`
              )
            } else if (index === 1) {
              // 腾讯地图
              window.open(
                `qqmap://map/routeplan?type=drive&from=我的位置&fromcoord=CurrentLocation&to=${pointData.clientName}&tocoord=${pointData.latitude},${pointData.longitude}&referer=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77`
              )
            } else if (index === 2) {
              // 百度地图
              window.open(
                `bdapp://map/direction?origin=我的位置&destination=name:${pointData.clientName}|latlng:${pointData.latitude},${pointData.longitude}&coord_type=gcj02&mode=driving&src=andr.sca.weiming`
              )
            }
          }
        }
      }).show()
      // 上报操作日志
      this.pushUserLog('开始导航')
    },
    goBack () {
      // this.$router.push({name:'index'})
      this.$router.back()
    },
    // 回车事件
    submitHandle () {
      this.$emit('enter', this.keyword)
    },
    // 失去焦点时
    blurHandle () {
      this.$emit('blur', this.keyword)
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/base/base.styl';

.purchase-detail-box {
  height: 100%;
  background: #efefef;
}
.visitInfo{
  padding: 100px 24px 10px 24px;
  background: #fff;
  margin-bottom: 20px
}
.visitInfo-list{
  padding: 10px
  margin: 10px 0
  border-bottom: 1px solid #efefef
}
.purchase-header {
  padding: 30px 24px;
  background: #fff;

  .clientName {
    font-size: 30px;
    color: #333;
    font-weight: bold;
  }
  .cover-btn {
    width 86px
    height 32px
    border-radius 3px
    font-size $font-S
    color $color-white
    right 24px
    &.covered {
        background $color-main
    }
    &.un-cover {
        background $color-red
    }
  }
  .info{
    display: inline
    float: left
    width: 70%
    div {
      margin: 20px auto
    }
  }
  .icon{
    padding-top: 50px
    float: right
    width: 30%
    height: 100%
    text-align: center
  }
  .choice-list {
    font-size: 16px
    height: 100%
    float: right
    margin: 20px
    img {
      width: 45px;
      height: 45px;
      margin-bottom: 10px
    }
  }
  .choice-list-phone{
    margin: 20px
    font-size: 16px
    height: 100%
    float: right
    right 8px
    a{
      color: #666;
    }
    img {
      width: 45px;
      height: 45px;
      margin-bottom: 10px
    }
  }
  .purchase-header-list {
    .purchase-header-item {
      min-height: 120px
      margin-top: 24px;
      color: #666;
      font-size: 26px;
    }
  }
}

.purchase-main {
  .listTitle{
    background-color #efefef
    padding: 10px 20px
  }
  .competitiveListTop{
    padding-bottom: 20px
  }
  .competitiveListBottom{
    padding-top: 20px
  }
  .btn-item{
    display:block
    margin:60px auto
    width 654px
    height 88px
    border-radius: 8px
    &.navigation{
      text-align: center
      font-size $font-XXXL
      color $color-white
      background $color-main
    }
  }
  .navBar {
    margin-top: 20px;
  }
  .purchase-main-list {
    background: #fff;
    margin-top: 5px;

    h4, .purchase-main-list-item {
      width: 686px;
      margin: 0 auto;
    }

    h4 {
      padding-top: 36px;
      line-height: 1;
      color: #333;
      font-size: 30px;
      font-weight: bold;
    }

    .purchase-main-list-item {
      border-bottom: 1px solid #efefef;
      padding-bottom: 36px;
      padding-top: 26px;
      color: #666;
      line-height: 1;
      font-size: 26px;

      .product {
        width: 80%
        height: auto
        word-wrap:break-word
        word-break:break-all
        overflow: hidden
        line-height: 35px
      }
      &:last-of-type {
        border-bottom: none;
      }
      .remark {
        width: 20%
      }
      .remarkInfo {
        float: left
        letter-spacing:3px
        line-height:45px
        width: 80%
      }
      .price-box {
        bottom: 0
        .count {
          bottom: 0
          margin-right: 4px;
        }
      }
    }
  }
}
</style>
